// extracted by mini-css-extract-plugin
export var textInput = "_kz-0";